{
 "schemaVersion": 1,
 "units": "inches",
 "generated": "2026-10-18",
 "defaultColorsBySize": {
  "1x1": "#E7DFCF",
  "1x4": "#CBBF9E",
  "2x2": "#9FB5A4",
  "2x6": "#7FA38C",
  "2x8": "#C9823F",
  "3x9": "#3A4157",
  "3x12": "#6E7F9A",
  "4x4": "#2F5F64",
  "4x8": "#8FB0B2",
  "4x12": "#A8574A",
  "6x6": "#D9B85C",
  "8x8": "#5B4A6B"
 },
 "patterns": [
  {
   "id": "log-cabin",
   "name": "Log cabin",
   "index": 1,
   "width": 12,
   "height": 12,
   "description": "The quilt block: a 4x4 center, then 4x4, 4x8, 4x8, 4x12 logs wrapping clockwise.",
   "sizes": [
    "4x4",
    "4x8",
    "4x12"
   ],
   "tileCounts": {
    "4x12": 1,
    "4x4": 2,
    "4x8": 2
   },
   "tileCount": 5,
   "tiles": [
    {
     "id": "t001",
     "x": 4,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 4,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 8,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "courthouse-steps",
   "name": "Courthouse steps",
   "index": 2,
   "width": 12,
   "height": 12,
   "description": "Log cabin's symmetric cousin: logs on opposite sides.",
   "sizes": [
    "4x4",
    "4x12"
   ],
   "tileCounts": {
    "4x12": 2,
    "4x4": 3
   },
   "tileCount": 5,
   "tiles": [
    {
     "id": "t001",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    }
   ]
  },
  {
   "id": "barn-raising",
   "name": "Barn raising",
   "index": 3,
   "width": 24,
   "height": 24,
   "description": "Four log cabins turned a quarter each, the classic quilt setting.",
   "sizes": [
    "4x4",
    "4x8",
    "4x12"
   ],
   "tileCounts": {
    "4x12": 4,
    "4x4": 8,
    "4x8": 8
   },
   "tileCount": 20,
   "tiles": [
    {
     "id": "t001",
     "x": 4,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 4,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 8,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 20,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 20,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 16,
     "y": 4,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t009",
     "x": 16,
     "y": 0,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t010",
     "x": 12,
     "y": 0,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t011",
     "x": 16,
     "y": 20,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 12,
     "y": 20,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 12,
     "y": 16,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t014",
     "x": 20,
     "y": 16,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t015",
     "x": 12,
     "y": 12,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 16,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 0,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 4,
     "y": 12,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t019",
     "x": 0,
     "y": 20,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t020",
     "x": 8,
     "y": 12,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    }
   ]
  },
  {
   "id": "courthouse-quad",
   "name": "Courthouse quad",
   "index": 4,
   "width": 24,
   "height": 24,
   "description": "Four courthouse-steps blocks.",
   "sizes": [
    "4x4",
    "4x12"
   ],
   "tileCounts": {
    "4x12": 8,
    "4x4": 12
   },
   "tileCount": 20,
   "tiles": [
    {
     "id": "t001",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 16,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 20,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 12,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 12,
     "y": 0,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t010",
     "x": 12,
     "y": 8,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t011",
     "x": 16,
     "y": 16,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 16,
     "y": 20,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 16,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 20,
     "y": 12,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t015",
     "x": 12,
     "y": 12,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t016",
     "x": 4,
     "y": 16,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 0,
     "y": 16,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 16,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 0,
     "y": 20,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t020",
     "x": 0,
     "y": 12,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "nine-patch",
   "name": "Nine patch",
   "index": 5,
   "width": 18,
   "height": 18,
   "description": "6x6 squares alternating with rail blocks.",
   "sizes": [
    "2x6",
    "6x6"
   ],
   "tileCounts": {
    "2x6": 12,
    "6x6": 5
   },
   "tileCount": 17,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 6,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 8,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 10,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 12,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 6,
     "y": 0,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 2,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t008",
     "x": 6,
     "y": 4,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t009",
     "x": 6,
     "y": 6,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 12,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t011",
     "x": 6,
     "y": 14,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t012",
     "x": 6,
     "y": 16,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t013",
     "x": 12,
     "y": 0,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 12,
     "y": 6,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t015",
     "x": 12,
     "y": 8,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t016",
     "x": 12,
     "y": 10,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t017",
     "x": 12,
     "y": 12,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "four-patch",
   "name": "Four patch",
   "index": 6,
   "width": 16,
   "height": 16,
   "description": "8x8s on one diagonal, four 4x4s on the other.",
   "sizes": [
    "4x4",
    "8x8"
   ],
   "tileCounts": {
    "4x4": 8,
    "8x8": 2
   },
   "tileCount": 10,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 12,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 12,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 8,
     "y": 8,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "chinese-coins",
   "name": "Chinese coins",
   "index": 7,
   "width": 16,
   "height": 16,
   "description": "Columns of 4-wide pieces at random heights, a strip-quilt classic.",
   "sizes": [
    "1x4",
    "4x4",
    "4x8",
    "4x12"
   ],
   "tileCounts": {
    "1x4": 8,
    "4x12": 1,
    "4x4": 1,
    "4x8": 5
   },
   "tileCount": 15,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 0,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 1,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t007",
     "x": 8,
     "y": 13,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t008",
     "x": 8,
     "y": 14,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t009",
     "x": 8,
     "y": 15,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t010",
     "x": 12,
     "y": 0,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t011",
     "x": 12,
     "y": 1,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t012",
     "x": 12,
     "y": 9,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 12,
     "y": 13,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t014",
     "x": 12,
     "y": 14,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t015",
     "x": 12,
     "y": 15,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "streak-of-lightning",
   "name": "Streak of lightning",
   "index": 8,
   "width": 12,
   "height": 12,
   "description": "2x6s zig-zagging one inch per course, 1x1 at the ends.",
   "sizes": [
    "1x1",
    "2x6"
   ],
   "tileCounts": {
    "1x1": 72,
    "2x6": 6
   },
   "tileCount": 78,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 1,
     "y": 2,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t015",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 2,
     "y": 4,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t028",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 3,
     "y": 6,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t041",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 2,
     "y": 8,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t054",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 1,
     "y": 10,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t067",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "trip-around-the-world",
   "name": "Trip around the world",
   "index": 9,
   "width": 12,
   "height": 12,
   "description": "Concentric rings out from a 4x4: 1x4 frame, 1x1 ring, 1x4 ring, 1x1 border.",
   "sizes": [
    "1x1",
    "1x4",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 80,
    "1x4": 12,
    "4x4": 1
   },
   "tileCount": 93,
   "tiles": [
    {
     "id": "t001",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 3,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 3,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 2,
     "y": 1,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t039",
     "x": 6,
     "y": 1,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t040",
     "x": 2,
     "y": 10,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t041",
     "x": 6,
     "y": 10,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t042",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t043",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t044",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t045",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t046",
     "x": 1,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "bricks",
   "name": "Bricks",
   "index": 10,
   "width": 12,
   "height": 12,
   "description": "2x6 running bond with 1x1 closing the half-offset.",
   "sizes": [
    "1x1",
    "2x6"
   ],
   "tileCounts": {
    "1x1": 36,
    "2x6": 9
   },
   "tileCount": 45,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 6,
     "y": 0,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 3,
     "y": 2,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t010",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 4,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t017",
     "x": 6,
     "y": 4,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t018",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 3,
     "y": 6,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t025",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 8,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t032",
     "x": 6,
     "y": 8,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t033",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 3,
     "y": 10,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t040",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "squared-square",
   "name": "Squared square",
   "index": 11,
   "width": 12,
   "height": 12,
   "description": "A square dissected into squares: one 8 and five 4s.",
   "sizes": [
    "4x4",
    "8x8"
   ],
   "tileCounts": {
    "4x4": 5,
    "8x8": 1
   },
   "tileCount": 6,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "spiral-of-squares",
   "name": "Spiral of squares",
   "index": 12,
   "width": 12,
   "height": 12,
   "description": "4, 4, 8, then a 4x12 to close: a Fibonacci-style spiral.",
   "sizes": [
    "4x4",
    "4x12",
    "8x8"
   ],
   "tileCounts": {
    "4x12": 1,
    "4x4": 2,
    "8x8": 1
   },
   "tileCount": 4,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 0,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 8,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "pythagorean-tiling",
   "name": "Pythagorean tiling",
   "index": 13,
   "width": 24,
   "height": 24,
   "description": "The two-square tiling (8 and 4) that proves a\u00b2+b\u00b2=c\u00b2; 4x4s true up the edges.",
   "sizes": [
    "4x4",
    "8x8"
   ],
   "tileCounts": {
    "4x4": 16,
    "8x8": 5
   },
   "tileCount": 21,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 16,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 4,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 16,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 4,
     "y": 12,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 12,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 8,
     "y": 20,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 16,
     "y": 8,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 12,
     "y": 16,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 20,
     "y": 16,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 12,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 16,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 20,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 20,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 0,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 0,
     "y": 20,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 4,
     "y": 20,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 20,
     "y": 20,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "equal-areas",
   "name": "Equal areas",
   "index": 14,
   "width": 12,
   "height": 12,
   "description": "Four pieces, each 36 sq in: a Blanche-style equal-area dissection.",
   "sizes": [
    "3x12",
    "6x6"
   ],
   "tileCounts": {
    "3x12": 2,
    "6x6": 2
   },
   "tileCount": 4,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 12,
     "h": 3,
     "size": "3x12",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 3,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 6,
     "y": 3,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 9,
     "w": 12,
     "h": 3,
     "size": "3x12",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "equal-areas-ii",
   "name": "Equal areas II",
   "index": 15,
   "width": 12,
   "height": 12,
   "description": "Same four areas, planks standing.",
   "sizes": [
    "3x12",
    "6x6"
   ],
   "tileCounts": {
    "3x12": 2,
    "6x6": 2
   },
   "tileCount": 4,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 3,
     "h": 12,
     "size": "3x12",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 3,
     "y": 0,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 9,
     "y": 0,
     "w": 3,
     "h": 12,
     "size": "3x12",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 3,
     "y": 6,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "four-and-a-half-mats",
   "name": "Four and a half mats",
   "index": 16,
   "width": 12,
   "height": 12,
   "description": "The 4.5-tatami room: four 4x8 mats around a half mat.",
   "sizes": [
    "4x4",
    "4x8"
   ],
   "tileCounts": {
    "4x4": 1,
    "4x8": 4
   },
   "tileCount": 5,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 8,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "rep-tile",
   "name": "Rep-tile",
   "index": 17,
   "width": 16,
   "height": 16,
   "description": "A square is four copies of itself: one 8x8 replaced by four 4x4s.",
   "sizes": [
    "4x4",
    "8x8"
   ],
   "tileCounts": {
    "4x4": 4,
    "8x8": 3
   },
   "tileCount": 7,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 8,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 12,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 12,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "carpet",
   "name": "Carpet",
   "index": 18,
   "width": 18,
   "height": 18,
   "description": "First step of the Sierpinski carpet: eight 6x6s around a mosaic hole.",
   "sizes": [
    "1x1",
    "6x6"
   ],
   "tileCounts": {
    "1x1": 36,
    "6x6": 8
   },
   "tileCount": 44,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 6,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 12,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 0,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 6,
     "y": 12,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 12,
     "y": 0,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 12,
     "y": 6,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 12,
     "y": 12,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 6,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "nested-pinwheel-long",
   "name": "Nested pinwheel, long",
   "index": 19,
   "width": 16,
   "height": 16,
   "description": "4x12 arms around an 8x8.",
   "sizes": [
    "4x12",
    "8x8"
   ],
   "tileCounts": {
    "4x12": 4,
    "8x8": 1
   },
   "tileCount": 5,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 12,
     "y": 0,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 12,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 4,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "triple-nest",
   "name": "Triple nest",
   "index": 20,
   "width": 16,
   "height": 16,
   "description": "4x12 pinwheel around a 2x6 pinwheel around a 4x4.",
   "sizes": [
    "2x6",
    "4x4",
    "4x12"
   ],
   "tileCounts": {
    "2x6": 4,
    "4x12": 4,
    "4x4": 1
   },
   "tileCount": 9,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 12,
     "y": 0,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 12,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 4,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 10,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t008",
     "x": 4,
     "y": 6,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t009",
     "x": 6,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pinwheel-2x6",
   "name": "Pinwheel, 2x6",
   "index": 21,
   "width": 8,
   "height": 8,
   "description": "Four 2x6s around a 4x4. The tightest pinwheel in the set.",
   "sizes": [
    "2x6",
    "4x4"
   ],
   "tileCounts": {
    "2x6": 4,
    "4x4": 1
   },
   "tileCount": 5,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 2,
     "y": 6,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pinwheel-quad",
   "name": "Pinwheel quad",
   "index": 22,
   "width": 16,
   "height": 16,
   "description": "Four 2x6 pinwheels.",
   "sizes": [
    "2x6",
    "4x4"
   ],
   "tileCounts": {
    "2x6": 16,
    "4x4": 4
   },
   "tileCount": 20,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 2,
     "y": 6,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 8,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 14,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t009",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t010",
     "x": 2,
     "y": 10,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 0,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t012",
     "x": 14,
     "y": 0,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t013",
     "x": 10,
     "y": 6,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t014",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 8,
     "y": 8,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t017",
     "x": 14,
     "y": 8,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 14,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t019",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 10,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "windmill-long",
   "name": "Windmill, long",
   "index": 23,
   "width": 15,
   "height": 15,
   "description": "3x12 arms around three 3x9s.",
   "sizes": [
    "3x9",
    "3x12"
   ],
   "tileCounts": {
    "3x12": 4,
    "3x9": 3
   },
   "tileCount": 7,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 12,
     "h": 3,
     "size": "3x12",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 12,
     "y": 0,
     "w": 3,
     "h": 12,
     "size": "3x12",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 3,
     "y": 12,
     "w": 12,
     "h": 3,
     "size": "3x12",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 3,
     "w": 3,
     "h": 12,
     "size": "3x12",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 3,
     "y": 3,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 3,
     "y": 6,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "windmill-solid-heart",
   "name": "Windmill, solid heart",
   "index": 24,
   "width": 12,
   "height": 12,
   "description": "3x9 windmill around a single 6x6.",
   "sizes": [
    "3x9",
    "6x6"
   ],
   "tileCounts": {
    "3x9": 4,
    "6x6": 1
   },
   "tileCount": 5,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 9,
     "y": 0,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 3,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 3,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 3,
     "y": 3,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pinwheel-solid-heart",
   "name": "Pinwheel, solid heart",
   "index": 25,
   "width": 10,
   "height": 10,
   "description": "2x8 pinwheel around a 6x6.",
   "sizes": [
    "2x8",
    "6x6"
   ],
   "tileCounts": {
    "2x8": 4,
    "6x6": 1
   },
   "tileCount": 5,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 2,
     "y": 8,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 2,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "finger-pinwheels",
   "name": "Finger pinwheels",
   "index": 26,
   "width": 10,
   "height": 10,
   "description": "1x4s spinning around nine 1x1s, four times.",
   "sizes": [
    "1x1",
    "1x4"
   ],
   "tileCounts": {
    "1x1": 36,
    "1x4": 16
   },
   "tileCount": 52,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 4,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 1,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 3,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 5,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t015",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t016",
     "x": 1,
     "y": 9,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t017",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t018",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 5,
     "y": 0,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t028",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t029",
     "x": 6,
     "y": 4,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t030",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t031",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 5,
     "y": 5,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t041",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t042",
     "x": 6,
     "y": 9,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t043",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t044",
     "x": 6,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "ashlar",
   "name": "Ashlar",
   "index": 27,
   "width": 12,
   "height": 12,
   "description": "Staggered 4x8 and 4x4 courses.",
   "sizes": [
    "4x4",
    "4x8"
   ],
   "tileCounts": {
    "4x4": 3,
    "4x8": 3
   },
   "tileCount": 6,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 4,
     "y": 4,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 8,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "ashlar-ii",
   "name": "Ashlar II",
   "index": 28,
   "width": 12,
   "height": 12,
   "description": "4x12, 4x8 and 4x4 courses, each joint offset.",
   "sizes": [
    "4x4",
    "4x8",
    "4x12"
   ],
   "tileCounts": {
    "4x12": 1,
    "4x4": 2,
    "4x8": 2
   },
   "tileCount": 5,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 4,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 8,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "opus-romano",
   "name": "Opus romano",
   "index": 29,
   "width": 16,
   "height": 16,
   "description": "Modular / Versailles-style: 8x8, 4x8 and 4x4 locked together.",
   "sizes": [
    "4x4",
    "4x8",
    "8x8"
   ],
   "tileCounts": {
    "4x4": 2,
    "4x8": 5,
    "8x8": 1
   },
   "tileCount": 8,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 12,
     "y": 4,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 4,
     "y": 8,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t007",
     "x": 4,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 8,
     "y": 12,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "opus-romano-ii",
   "name": "Opus romano II",
   "index": 30,
   "width": 24,
   "height": 24,
   "description": "Random modular layout on a 4-inch grid.",
   "sizes": [
    "4x4",
    "4x8",
    "4x12",
    "8x8"
   ],
   "tileCounts": {
    "4x12": 3,
    "4x4": 1,
    "4x8": 9,
    "8x8": 2
   },
   "tileCount": 15,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 12,
     "y": 0,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 16,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 20,
     "y": 0,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 4,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t007",
     "x": 16,
     "y": 4,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t008",
     "x": 12,
     "y": 8,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t009",
     "x": 20,
     "y": 8,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 12,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 12,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t012",
     "x": 16,
     "y": 12,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t013",
     "x": 20,
     "y": 16,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 20,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t015",
     "x": 12,
     "y": 20,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "opus-romano-iii",
   "name": "Opus romano III",
   "index": 31,
   "width": 24,
   "height": 24,
   "description": "Another random modular layout.",
   "sizes": [
    "4x4",
    "4x8",
    "4x12",
    "8x8"
   ],
   "tileCounts": {
    "4x12": 3,
    "4x4": 5,
    "4x8": 9,
    "8x8": 1
   },
   "tileCount": 18,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 12,
     "y": 0,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 16,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 20,
     "y": 0,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t007",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t008",
     "x": 16,
     "y": 4,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t009",
     "x": 12,
     "y": 8,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t010",
     "x": 20,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 0,
     "y": 12,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t012",
     "x": 4,
     "y": 12,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t013",
     "x": 8,
     "y": 12,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t014",
     "x": 16,
     "y": 12,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t015",
     "x": 16,
     "y": 16,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 20,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 20,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 12,
     "y": 20,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "running-bond-4x8",
   "name": "Running bond, 4x8",
   "index": 32,
   "width": 16,
   "height": 12,
   "description": "Half-offset 4x8 courses, 4x4 closers.",
   "sizes": [
    "4x4",
    "4x8"
   ],
   "tileCounts": {
    "4x4": 2,
    "4x8": 5
   },
   "tileCount": 7,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 4,
     "y": 4,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 12,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 8,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t007",
     "x": 8,
     "y": 8,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "corner-stone",
   "name": "Corner stone",
   "index": 33,
   "width": 12,
   "height": 12,
   "description": "8x8, two 4x8s, one 4x4.",
   "sizes": [
    "4x4",
    "4x8",
    "8x8"
   ],
   "tileCounts": {
    "4x4": 1,
    "4x8": 2,
    "8x8": 1
   },
   "tileCount": 4,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 8,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "twin-stones",
   "name": "Twin stones",
   "index": 34,
   "width": 16,
   "height": 16,
   "description": "8x8s on the diagonal, 4x8 pairs between.",
   "sizes": [
    "4x8",
    "8x8"
   ],
   "tileCounts": {
    "4x8": 4,
    "8x8": 2
   },
   "tileCount": 6,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 8,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 8,
     "y": 0,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 8,
     "y": 4,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    }
   ]
  },
  {
   "id": "big-windowpane",
   "name": "Big windowpane",
   "index": 35,
   "width": 20,
   "height": 20,
   "description": "8x8 panes, 4x8 mullions, 4x4 at the crossing.",
   "sizes": [
    "4x4",
    "4x8",
    "8x8"
   ],
   "tileCounts": {
    "4x4": 1,
    "4x8": 4,
    "8x8": 4
   },
   "tileCount": 9,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 12,
     "y": 0,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 12,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 12,
     "y": 12,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 12,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 8,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t008",
     "x": 12,
     "y": 8,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t009",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "corridor",
   "name": "Corridor",
   "index": 36,
   "width": 12,
   "height": 12,
   "description": "4x12 planks separated by 2x6 courses.",
   "sizes": [
    "2x6",
    "4x12"
   ],
   "tileCounts": {
    "2x6": 4,
    "4x12": 2
   },
   "tileCount": 6,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 4,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 6,
     "y": 4,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 6,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 10,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 6,
     "y": 10,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "spiral",
   "name": "Spiral",
   "index": 37,
   "width": 12,
   "height": 12,
   "description": "4x12, 4x8, 4x8 spiraling in to two 4x4s.",
   "sizes": [
    "4x4",
    "4x8",
    "4x12"
   ],
   "tileCounts": {
    "4x12": 1,
    "4x4": 2,
    "4x8": 2
   },
   "tileCount": 5,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 8,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "finger-bond",
   "name": "Finger bond",
   "index": 38,
   "width": 12,
   "height": 12,
   "description": "1x4s offset one inch per course, 1x1 closers.",
   "sizes": [
    "1x1",
    "1x4"
   ],
   "tileCounts": {
    "1x1": 36,
    "1x4": 27
   },
   "tileCount": 63,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 1,
     "y": 1,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 5,
     "y": 1,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t007",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 2,
     "y": 2,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 2,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t014",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 3,
     "y": 3,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t020",
     "x": 7,
     "y": 3,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t021",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t023",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t024",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t025",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 1,
     "y": 5,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t027",
     "x": 5,
     "y": 5,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t028",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 2,
     "y": 6,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t034",
     "x": 6,
     "y": 6,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t035",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 3,
     "y": 7,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t041",
     "x": 7,
     "y": 7,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t042",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t044",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t045",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t046",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 1,
     "y": 9,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t048",
     "x": 5,
     "y": 9,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t049",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 2,
     "y": 10,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t055",
     "x": 6,
     "y": 10,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t056",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 3,
     "y": 11,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t062",
     "x": 7,
     "y": 11,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t063",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "finger-frames",
   "name": "Finger frames",
   "index": 39,
   "width": 12,
   "height": 12,
   "description": "4x4s framed by 1x4s with 1x1 corners.",
   "sizes": [
    "1x1",
    "1x4",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 16,
    "1x4": 16,
    "4x4": 4
   },
   "tileCount": 36,
   "tiles": [
    {
     "id": "t001",
     "x": 1,
     "y": 0,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 1,
     "y": 5,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 5,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 1,
     "y": 1,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 1,
     "y": 6,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t011",
     "x": 1,
     "y": 11,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t012",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t013",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 1,
     "y": 7,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 7,
     "y": 0,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t020",
     "x": 7,
     "y": 5,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t021",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t022",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t023",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 7,
     "y": 1,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 7,
     "y": 6,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t029",
     "x": 7,
     "y": 11,
     "w": 4,
     "h": 1,
     "size": "1x4",
     "orientation": "landscape"
    },
    {
     "id": "t030",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t031",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t032",
     "x": 6,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 7,
     "y": 7,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "picket",
   "name": "Picket",
   "index": 40,
   "width": 12,
   "height": 12,
   "description": "Standing 1x4 pickets with 1x1 rails between.",
   "sizes": [
    "1x1",
    "1x4"
   ],
   "tileCounts": {
    "1x1": 72,
    "1x4": 18
   },
   "tileCount": 90,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 1,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t017",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t018",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t019",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 3,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t032",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t033",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t034",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 5,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t047",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t048",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t049",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t062",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t063",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t064",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t077",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t078",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 4,
     "size": "1x4",
     "orientation": "portrait"
    },
    {
     "id": "t079",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "big-dotted-grid",
   "name": "Big dotted grid",
   "index": 41,
   "width": 13,
   "height": 13,
   "description": "6x6s on a 7-inch pitch with 1x1 channels.",
   "sizes": [
    "1x1",
    "6x6"
   ],
   "tileCounts": {
    "1x1": 25,
    "6x6": 4
   },
   "tileCount": 29,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 7,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 7,
     "y": 0,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 7,
     "y": 7,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 6,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 12,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 6,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "composition-i",
   "name": "Composition I",
   "index": 42,
   "width": 12,
   "height": 12,
   "description": "Six pieces: two 6x6s, two 2x6s, a 2x8 and a 4x8.",
   "sizes": [
    "2x6",
    "2x8",
    "4x8",
    "6x6"
   ],
   "tileCounts": {
    "2x6": 2,
    "2x8": 1,
    "4x8": 1,
    "6x6": 2
   },
   "tileCount": 6,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 6,
     "y": 0,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 8,
     "y": 2,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 6,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 6,
     "y": 10,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "composition-ii",
   "name": "Composition II",
   "index": 43,
   "width": 12,
   "height": 12,
   "description": "Four pieces: a 4x12 and three 4x8s.",
   "sizes": [
    "4x8",
    "4x12"
   ],
   "tileCounts": {
    "4x12": 1,
    "4x8": 3
   },
   "tileCount": 4,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 12,
     "size": "4x12",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    }
   ]
  },
  {
   "id": "composition-iii",
   "name": "Composition III",
   "index": 44,
   "width": 12,
   "height": 12,
   "description": "Five planks: 3x12, 3x9, and three standing 3x9s.",
   "sizes": [
    "3x9",
    "3x12"
   ],
   "tileCounts": {
    "3x12": 1,
    "3x9": 4
   },
   "tileCount": 5,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 3,
     "h": 12,
     "size": "3x12",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 3,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 3,
     "y": 3,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 3,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 9,
     "y": 3,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    }
   ]
  },
  {
   "id": "bar-stripe",
   "name": "Bar & stripe",
   "index": 45,
   "width": 12,
   "height": 12,
   "description": "Two 4x12 bars around a 4x4 and a 4x8.",
   "sizes": [
    "4x4",
    "4x8",
    "4x12"
   ],
   "tileCounts": {
    "4x12": 2,
    "4x4": 1,
    "4x8": 1
   },
   "tileCount": 4,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 4,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 8,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "checker-big-mosaic",
   "name": "Checker, big mosaic",
   "index": 46,
   "width": 12,
   "height": 12,
   "description": "6x6s alternating with 36-piece 1x1 squares.",
   "sizes": [
    "1x1",
    "6x6"
   ],
   "tileCounts": {
    "1x1": 72,
    "6x6": 2
   },
   "tileCount": 74,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 6,
     "y": 6,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "stone-pinwheel",
   "name": "Stone & pinwheel",
   "index": 47,
   "width": 16,
   "height": 16,
   "description": "8x8s alternating with 2x6 pinwheels.",
   "sizes": [
    "2x6",
    "4x4",
    "8x8"
   ],
   "tileCounts": {
    "2x6": 8,
    "4x4": 2,
    "8x8": 2
   },
   "tileCount": 12,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 8,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 2,
     "y": 14,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 10,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 8,
     "y": 0,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t008",
     "x": 14,
     "y": 0,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 6,
     "w": 6,
     "h": 2,
     "size": "2x6",
     "orientation": "landscape"
    },
    {
     "id": "t010",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t011",
     "x": 10,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 8,
     "y": 8,
     "w": 8,
     "h": 8,
     "size": "8x8",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pencil-frame-log-cabin",
   "name": "Pencil frame, log cabin",
   "index": 48,
   "width": 14,
   "height": 14,
   "description": "The log cabin with a 1x1 border.",
   "sizes": [
    "1x1",
    "4x4",
    "4x8",
    "4x12"
   ],
   "tileCounts": {
    "1x1": 52,
    "4x12": 1,
    "4x4": 2,
    "4x8": 2
   },
   "tileCount": 57,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 10,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 12,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 12,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 13,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 13,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 13,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 13,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 13,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 13,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 13,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 13,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 13,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 13,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 13,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 13,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 13,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 0,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 13,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 5,
     "y": 1,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 9,
     "y": 1,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 5,
     "y": 5,
     "w": 8,
     "h": 4,
     "size": "4x8",
     "orientation": "landscape"
    },
    {
     "id": "t056",
     "x": 1,
     "y": 1,
     "w": 4,
     "h": 8,
     "size": "4x8",
     "orientation": "portrait"
    },
    {
     "id": "t057",
     "x": 1,
     "y": 9,
     "w": 12,
     "h": 4,
     "size": "4x12",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "pencil-frame-windmill",
   "name": "Pencil frame, windmill",
   "index": 49,
   "width": 14,
   "height": 14,
   "description": "Solid-heart windmill with a 1x1 border.",
   "sizes": [
    "1x1",
    "3x9",
    "6x6"
   ],
   "tileCounts": {
    "1x1": 52,
    "3x9": 4,
    "6x6": 1
   },
   "tileCount": 57,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 10,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 12,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 12,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 13,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 13,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 13,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 13,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 13,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 13,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 13,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 13,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 13,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 13,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 13,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 13,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 13,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 0,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 13,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 1,
     "y": 1,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t054",
     "x": 10,
     "y": 1,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t055",
     "x": 4,
     "y": 10,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t056",
     "x": 1,
     "y": 4,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t057",
     "x": 4,
     "y": 4,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "squares-over-rails",
   "name": "Squares over rails",
   "index": 50,
   "width": 12,
   "height": 12,
   "description": "Two 6x6s over three lying 2x6 courses.",
   "sizes": [
    "2x6",
    "6x6"
   ],
   "tileCounts": {
    "2x6": 6,
    "6x6": 2
   },
   "tileCount": 8,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 6,
     "y": 0,
     "w": 6,
     "h": 6,
     "size": "6x6",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 6,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 6,
     "y": 6,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t007",
     "x": 8,
     "y": 6,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    },
    {
     "id": "t008",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 6,
     "size": "2x6",
     "orientation": "portrait"
    }
   ]
  },
  {
   "id": "planks-long-short",
   "name": "Planks, long & short",
   "index": 51,
   "width": 12,
   "height": 12,
   "description": "3x12 courses alternating with 3x9 plus a 3x3 mosaic.",
   "sizes": [
    "1x1",
    "3x9",
    "3x12"
   ],
   "tileCounts": {
    "1x1": 18,
    "3x12": 2,
    "3x9": 2
   },
   "tileCount": 22,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 12,
     "h": 3,
     "size": "3x12",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 3,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 0,
     "y": 6,
     "w": 12,
     "h": 3,
     "size": "3x12",
     "orientation": "landscape"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 3,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "windmill",
   "name": "Windmill",
   "index": 52,
   "width": 12,
   "height": 12,
   "description": "Four 3x9s spin around a 2x2 center. The cleanest way to use the 3x9.",
   "sizes": [
    "2x2",
    "3x9"
   ],
   "tileCounts": {
    "2x2": 9,
    "3x9": 4
   },
   "tileCount": 13,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 9,
     "y": 0,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 3,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 3,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 3,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 5,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 7,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 5,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 7,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 3,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 7,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pinwheel",
   "name": "Pinwheel",
   "index": 53,
   "width": 12,
   "height": 12,
   "description": "2x8 pinwheel with an off-center 4x4, wrapped in a 1x1 pencil border.",
   "sizes": [
    "1x1",
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 44,
    "2x2": 5,
    "2x8": 4,
    "4x4": 1
   },
   "tileCount": 54,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 1,
     "y": 1,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t046",
     "x": 9,
     "y": 1,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t047",
     "x": 3,
     "y": 9,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t048",
     "x": 1,
     "y": 3,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t049",
     "x": 3,
     "y": 3,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 7,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 7,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 3,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 5,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 7,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "running-bond",
   "name": "Running bond",
   "index": 54,
   "width": 16,
   "height": 12,
   "description": "Half-offset 2x8 courses; the stagger is closed with 2x2 pairs so no cuts.",
   "sizes": [
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "2x2": 12,
    "2x8": 9
   },
   "tileCount": 21,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 2,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 12,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 14,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 0,
     "y": 4,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t009",
     "x": 8,
     "y": 4,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 4,
     "y": 6,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t013",
     "x": 12,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 14,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 0,
     "y": 8,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t016",
     "x": 8,
     "y": 8,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t017",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 4,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t020",
     "x": 12,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 14,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "dotted-grid",
   "name": "Dotted grid",
   "index": 55,
   "width": 14,
   "height": 14,
   "description": "4x4s on a 5-inch pitch with 1x1 channels between them.",
   "sizes": [
    "1x1",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 52,
    "4x4": 9
   },
   "tileCount": 61,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 5,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 10,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 5,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 5,
     "y": 5,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 5,
     "y": 10,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 10,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 10,
     "y": 5,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 10,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 12,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 13,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 12,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 13,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 4,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 9,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 4,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 9,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "cobble",
   "name": "Cobble",
   "index": 56,
   "width": 12,
   "height": 12,
   "description": "Checkerboard of 2x2s and 2x2 quads of 1x1.",
   "sizes": [
    "1x1",
    "2x2"
   ],
   "tileCounts": {
    "1x1": 72,
    "2x2": 18
   },
   "tileCount": 90,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 4,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 6,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "framed-square",
   "name": "Framed square",
   "index": 57,
   "width": 12,
   "height": 12,
   "description": "Concentric: 4x4 heart, 2x2 ring, two 1x1 rings.",
   "sizes": [
    "1x1",
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 80,
    "2x2": 12,
    "4x4": 1
   },
   "tileCount": 93,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 1,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 2,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 8,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pinwheel-mosaic-heart",
   "name": "Pinwheel, mosaic heart",
   "index": 58,
   "width": 12,
   "height": 12,
   "description": "Same 2x8 spin, but the center is a 6x6 field of 1x1.",
   "sizes": [
    "1x1",
    "2x8"
   ],
   "tileCounts": {
    "1x1": 80,
    "2x8": 4
   },
   "tileCount": 84,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 1,
     "y": 1,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t046",
     "x": 9,
     "y": 1,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t047",
     "x": 3,
     "y": 9,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t048",
     "x": 1,
     "y": 3,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t049",
     "x": 3,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 5,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 6,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "standing-bond",
   "name": "Standing bond",
   "index": 59,
   "width": 12,
   "height": 16,
   "description": "Running bond turned on end. Tall, narrow module.",
   "sizes": [
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "2x2": 12,
    "2x8": 9
   },
   "tileCount": 21,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 2,
     "y": 14,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 6,
     "y": 4,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 14,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t016",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 14,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "windowpane",
   "name": "Windowpane",
   "index": 60,
   "width": 16,
   "height": 16,
   "description": "4x4 panes with 2x2 mullions.",
   "sizes": [
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 28,
    "4x4": 9
   },
   "tileCount": 37,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 6,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 6,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 12,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 12,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 12,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 4,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 6,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 12,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 14,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 4,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 12,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 14,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 4,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 10,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 4,
     "y": 14,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 10,
     "y": 14,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "tatami",
   "name": "Tatami",
   "index": 61,
   "width": 12,
   "height": 12,
   "description": "Four 3x9s laid like mats; the leftover L is a mosaic strip of 1x1.",
   "sizes": [
    "1x1",
    "3x9"
   ],
   "tileCounts": {
    "1x1": 36,
    "3x9": 4
   },
   "tileCount": 40,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 3,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 9,
     "y": 0,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 3,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 6,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "ladder-stripes",
   "name": "Ladder stripes",
   "index": 62,
   "width": 12,
   "height": 12,
   "description": "Alternating columns: a 2x8 capped by 2x2s, then a run of 2x2s.",
   "sizes": [
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "2x2": 24,
    "2x8": 3
   },
   "tileCount": 27,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t012",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 6,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 6,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t021",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "x-marks",
   "name": "X marks",
   "index": 63,
   "width": 12,
   "height": 12,
   "description": "Five 4x4s on the diagonals, 2x2 everywhere else.",
   "sizes": [
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 16,
    "4x4": 5
   },
   "tileCount": 21,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 8,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "diagonal",
   "name": "Diagonal",
   "index": 64,
   "width": 12,
   "height": 12,
   "description": "A single 4x4 diagonal across a 2x2 field.",
   "sizes": [
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 24,
    "4x4": 3
   },
   "tileCount": 27,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pencil-border",
   "name": "Pencil border",
   "index": 65,
   "width": 12,
   "height": 12,
   "description": "1x1 border, 2x2 field. The quiet one.",
   "sizes": [
    "1x1",
    "2x2"
   ],
   "tileCounts": {
    "1x1": 44,
    "2x2": 25
   },
   "tileCount": 69,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 1,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 3,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 5,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 7,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 9,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 1,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 3,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 5,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 7,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 9,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 1,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 3,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 5,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 7,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 9,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 1,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 3,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 5,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 7,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 9,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 1,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 3,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 5,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 7,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 9,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "framed-diagonal",
   "name": "Framed diagonal",
   "index": 66,
   "width": 12,
   "height": 12,
   "description": "2x2 frame, two 4x4s kissing at the center.",
   "sizes": [
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 28,
    "4x4": 2
   },
   "tileCount": 30,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 6,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 6,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 4,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 2,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "offset-bond",
   "name": "Offset bond",
   "index": 67,
   "width": 12,
   "height": 12,
   "description": "4x4 courses staggered by half, closed with 2x2 pairs.",
   "sizes": [
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 4,
    "4x4": 8
   },
   "tileCount": 12,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "mondrian",
   "name": "Mondrian",
   "index": 68,
   "width": 12,
   "height": 12,
   "description": "Nine tiles. Three 4x4s locked in by six 2x8s.",
   "sizes": [
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x8": 6,
    "4x4": 3
   },
   "tileCount": 9,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t007",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t008",
     "x": 6,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "dashes",
   "name": "Dashes",
   "index": 69,
   "width": 12,
   "height": 12,
   "description": "2x8s alternating left and right, 2x2s at the ends.",
   "sizes": [
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "2x2": 12,
    "2x8": 6
   },
   "tileCount": 18,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 4,
     "y": 2,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 4,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t008",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 4,
     "y": 6,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 8,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t014",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 4,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "four-corners",
   "name": "Four corners",
   "index": 70,
   "width": 12,
   "height": 12,
   "description": "A 4x4 in each corner, 2x2 cross through the middle.",
   "sizes": [
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 20,
    "4x4": 4
   },
   "tileCount": 24,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 4,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 6,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 4,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 6,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 8,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "hopscotch",
   "name": "Hopscotch",
   "index": 71,
   "width": 12,
   "height": 12,
   "description": "True hopscotch lattice (4x4 + 2x2); 1x1s true up the edges.",
   "sizes": [
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 16,
    "4x4": 5
   },
   "tileCount": 21,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 2,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 6,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 6,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "shifted-planks",
   "name": "Shifted planks",
   "index": 72,
   "width": 12,
   "height": 12,
   "description": "3x9s staggered left/right with 3x3 mosaic ends.",
   "sizes": [
    "1x1",
    "3x9"
   ],
   "tileCounts": {
    "1x1": 36,
    "3x9": 4
   },
   "tileCount": 40,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 3,
     "y": 3,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t021",
     "x": 0,
     "y": 6,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t022",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 3,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "freeform",
   "name": "Freeform",
   "index": 73,
   "width": 12,
   "height": 12,
   "description": "A deliberately irregular mix of all four square-and-plank sizes.",
   "sizes": [
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 4,
    "2x8": 6,
    "4x4": 2
   },
   "tileCount": 12,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t007",
     "x": 2,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "bullseye",
   "name": "Bullseye",
   "index": 74,
   "width": 12,
   "height": 12,
   "description": "2x2 center, 1x1 ring, 2x2 ring, 1x1 ring, 1x1 border.",
   "sizes": [
    "1x1",
    "2x2"
   ],
   "tileCounts": {
    "1x1": 92,
    "2x2": 13
   },
   "tileCount": 105,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 5,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 2,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 8,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 1,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t094",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t095",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t096",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t097",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t098",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t099",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t100",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t101",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t102",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t103",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t104",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t105",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "zigzag",
   "name": "Zigzag",
   "index": 75,
   "width": 12,
   "height": 12,
   "description": "2x8s stepping in and back out; 2x2s fill the margins.",
   "sizes": [
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "2x2": 12,
    "2x8": 6
   },
   "tileCount": 18,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 2,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 4,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 4,
     "y": 6,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 8,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t007",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pinstripe",
   "name": "Pinstripe",
   "index": 76,
   "width": 12,
   "height": 12,
   "description": "A 1x1 pinstripe under every 2x8 course.",
   "sizes": [
    "1x1",
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "1x1": 48,
    "2x2": 8,
    "2x8": 4
   },
   "tileCount": 60,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 2,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 4,
     "y": 3,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t019",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 5,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 6,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t032",
     "x": 8,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 0,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 2,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 4,
     "y": 9,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t049",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pencil-border-dashes",
   "name": "Pencil border, dashes",
   "index": 77,
   "width": 12,
   "height": 12,
   "description": "Staggered 2x8s inside a 1x1 frame.",
   "sizes": [
    "1x1",
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "1x1": 44,
    "2x2": 5,
    "2x8": 5
   },
   "tileCount": 54,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 1,
     "y": 1,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t046",
     "x": 9,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 1,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 3,
     "y": 3,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t049",
     "x": 1,
     "y": 5,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t050",
     "x": 9,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 1,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 3,
     "y": 7,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t053",
     "x": 1,
     "y": 9,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t054",
     "x": 9,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pencil-border-four-corners",
   "name": "Pencil border, four corners",
   "index": 78,
   "width": 12,
   "height": 12,
   "description": "Four 4x4s and a 2x2 cross inside a 1x1 frame.",
   "sizes": [
    "1x1",
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 44,
    "2x2": 9,
    "4x4": 4
   },
   "tileCount": 57,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 1,
     "y": 1,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 7,
     "y": 1,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 1,
     "y": 7,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 7,
     "y": 7,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 5,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 5,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 1,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 3,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 5,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 7,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 9,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 5,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 5,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pencil-border-cobble",
   "name": "Pencil border, cobble",
   "index": 79,
   "width": 12,
   "height": 12,
   "description": "Cobble checker inside a 1x1 frame.",
   "sizes": [
    "1x1",
    "2x2"
   ],
   "tileCounts": {
    "1x1": 92,
    "2x2": 13
   },
   "tileCount": 105,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 1,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 1,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 1,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 3,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 3,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 5,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 5,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 5,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 7,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 7,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t094",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t095",
     "x": 9,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t096",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t097",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t098",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t099",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t100",
     "x": 9,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t101",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t102",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t103",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t104",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t105",
     "x": 9,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "banded-stripes",
   "name": "Banded stripes",
   "index": 80,
   "width": 12,
   "height": 12,
   "description": "2x2 band around four lying 2x8s.",
   "sizes": [
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "2x2": 20,
    "2x8": 4
   },
   "tileCount": 24,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 2,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t022",
     "x": 2,
     "y": 4,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t023",
     "x": 2,
     "y": 6,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t024",
     "x": 2,
     "y": 8,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "banded-standing",
   "name": "Banded standing",
   "index": 81,
   "width": 12,
   "height": 12,
   "description": "2x2 band around four standing 2x8s.",
   "sizes": [
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "2x2": 20,
    "2x8": 4
   },
   "tileCount": 24,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t022",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t023",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t024",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    }
   ]
  },
  {
   "id": "banded-quad",
   "name": "Banded quad",
   "index": 82,
   "width": 12,
   "height": 12,
   "description": "2x2 band around four 4x4s.",
   "sizes": [
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 20,
    "4x4": 4
   },
   "tileCount": 24,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 6,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 2,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 6,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "banded-concentric",
   "name": "Banded concentric",
   "index": 83,
   "width": 12,
   "height": 12,
   "description": "2x2 band, 2x2 ring, 4x4 heart.",
   "sizes": [
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 32,
    "4x4": 1
   },
   "tileCount": 33,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 8,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 2,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "banded-mosaic",
   "name": "Banded mosaic",
   "index": 84,
   "width": 12,
   "height": 12,
   "description": "2x2 band around a 1x1 field.",
   "sizes": [
    "1x1",
    "2x2"
   ],
   "tileCounts": {
    "1x1": 64,
    "2x2": 20
   },
   "tileCount": 84,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 3,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 5,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 6,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "banded-split",
   "name": "Banded split",
   "index": 85,
   "width": 12,
   "height": 12,
   "description": "Two planks over two 4x4s, in a 2x2 band.",
   "sizes": [
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 20,
    "2x8": 2,
    "4x4": 2
   },
   "tileCount": 24,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 2,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t022",
     "x": 2,
     "y": 4,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t023",
     "x": 2,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 6,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "planks-mosaic-edge",
   "name": "Planks, mosaic edge",
   "index": 86,
   "width": 12,
   "height": 12,
   "description": "Four stacked 3x9s with a 1x1 edge strip.",
   "sizes": [
    "1x1",
    "3x9"
   ],
   "tileCounts": {
    "1x1": 36,
    "3x9": 4
   },
   "tileCount": 40,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 3,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 6,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "planks-split",
   "name": "Planks, split",
   "index": 87,
   "width": 12,
   "height": 12,
   "description": "3x9 pairs stepped once; 1x1 fills the notches.",
   "sizes": [
    "1x1",
    "3x9"
   ],
   "tileCounts": {
    "1x1": 36,
    "3x9": 4
   },
   "tileCount": 40,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 3,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 3,
     "y": 6,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 3,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "windmill-mosaic-heart",
   "name": "Windmill, mosaic heart",
   "index": 88,
   "width": 12,
   "height": 12,
   "description": "3x9 windmill around a 6x6 field of 1x1.",
   "sizes": [
    "1x1",
    "3x9"
   ],
   "tileCounts": {
    "1x1": 36,
    "3x9": 4
   },
   "tileCount": 40,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 9,
     "y": 0,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 3,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 3,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 3,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 5,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 6,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "standing-planks",
   "name": "Standing planks",
   "index": 89,
   "width": 12,
   "height": 12,
   "description": "Four standing 3x9s on a lying one; 3x3 mosaic corner.",
   "sizes": [
    "1x1",
    "3x9"
   ],
   "tileCounts": {
    "1x1": 9,
    "3x9": 5
   },
   "tileCount": 14,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 3,
     "y": 0,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 6,
     "y": 0,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 9,
     "y": 0,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "five-planks",
   "name": "Five planks",
   "index": 90,
   "width": 12,
   "height": 12,
   "description": "Five 3x9s and nine 1x1.",
   "sizes": [
    "1x1",
    "3x9"
   ],
   "tileCounts": {
    "1x1": 9,
    "3x9": 5
   },
   "tileCount": 14,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 3,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 6,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 9,
     "y": 0,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "windmill-offset-heart",
   "name": "Windmill, offset heart",
   "index": 91,
   "width": 12,
   "height": 12,
   "description": "3x9 windmill with a 4x4 pushed to one corner of the center.",
   "sizes": [
    "2x2",
    "3x9",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 5,
    "3x9": 4,
    "4x4": 1
   },
   "tileCount": 10,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 9,
     "y": 0,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 3,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 3,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 3,
     "y": 3,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 7,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 7,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 5,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 7,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "plus",
   "name": "Plus",
   "index": 92,
   "width": 12,
   "height": 12,
   "description": "Five 4x4s in a cross, 2x2 corners.",
   "sizes": [
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 16,
    "4x4": 5
   },
   "tileCount": 21,
   "tiles": [
    {
     "id": "t001",
     "x": 4,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 2,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "nine-square-mosaic-center",
   "name": "Nine square, mosaic center",
   "index": 93,
   "width": 12,
   "height": 12,
   "description": "Eight 4x4s around a 16-piece 1x1 center.",
   "sizes": [
    "1x1",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 16,
    "4x4": 8
   },
   "tileCount": 24,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 5,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 6,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "staircase",
   "name": "Staircase",
   "index": 94,
   "width": 12,
   "height": 12,
   "description": "4x4 courses stepping two inches per row.",
   "sizes": [
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 8,
    "4x4": 7
   },
   "tileCount": 15,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 2,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "twin-corners",
   "name": "Twin corners",
   "index": 95,
   "width": 12,
   "height": 12,
   "description": "Two 4x4s on the diagonal, locked by 2x8 pairs.",
   "sizes": [
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x8": 6,
    "4x4": 3
   },
   "tileCount": 9,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 2,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 4,
     "y": 4,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t009",
     "x": 6,
     "y": 4,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    }
   ]
  },
  {
   "id": "stepped-bond",
   "name": "Stepped bond",
   "index": 96,
   "width": 12,
   "height": 12,
   "description": "2x8s offset a third each course.",
   "sizes": [
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "2x2": 12,
    "2x8": 6
   },
   "tileCount": 18,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 2,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 4,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 6,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 2,
     "y": 8,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 4,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "wave",
   "name": "Wave",
   "index": 97,
   "width": 12,
   "height": 12,
   "description": "2x8s drifting right then back.",
   "sizes": [
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "2x2": 12,
    "2x8": 6
   },
   "tileCount": 18,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 2,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 4,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 2,
     "y": 6,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 8,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t014",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 2,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "woven-corner",
   "name": "Woven corner",
   "index": 98,
   "width": 12,
   "height": 12,
   "description": "A basketweave block with 4x4s on two sides.",
   "sizes": [
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x8": 4,
    "4x4": 5
   },
   "tileCount": 9,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 2,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 4,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 6,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "rails",
   "name": "Rails",
   "index": 99,
   "width": 12,
   "height": 12,
   "description": "2x8 rails top and bottom, six 4x4s between.",
   "sizes": [
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 4,
    "2x8": 2,
    "4x4": 6
   },
   "tileCount": 12,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 4,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 4,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 8,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 4,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 8,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pinwheel-offset",
   "name": "Pinwheel, offset",
   "index": 100,
   "width": 12,
   "height": 12,
   "description": "2x8 pinwheel pushed to a corner, with 2x8 and 2x2 fill.",
   "sizes": [
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "2x2": 12,
    "2x8": 6
   },
   "tileCount": 18,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 2,
     "y": 8,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 0,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t009",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 4,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 6,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 4,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 6,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "four-corners-mosaic",
   "name": "Four corners, mosaic",
   "index": 101,
   "width": 12,
   "height": 12,
   "description": "4x4 corners in a 1x1 field.",
   "sizes": [
    "1x1",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 80,
    "4x4": 4
   },
   "tileCount": 84,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 5,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 6,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "mosaic-cross",
   "name": "Mosaic cross",
   "index": 102,
   "width": 12,
   "height": 12,
   "description": "A 2x2 cross floating in 1x1.",
   "sizes": [
    "1x1",
    "2x2"
   ],
   "tileCounts": {
    "1x1": 108,
    "2x2": 9
   },
   "tileCount": 117,
   "tiles": [
    {
     "id": "t001",
     "x": 5,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 5,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 5,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 5,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 5,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 1,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 7,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 9,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 1,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 3,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t094",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t095",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t096",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t097",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t098",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t099",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t100",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t101",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t102",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t103",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t104",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t105",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t106",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t107",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t108",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t109",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t110",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t111",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t112",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t113",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t114",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t115",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t116",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t117",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "diamond",
   "name": "Diamond",
   "index": 103,
   "width": 12,
   "height": 12,
   "description": "A 2x2 diamond outline with a center stone, in 1x1.",
   "sizes": [
    "1x1",
    "2x2"
   ],
   "tileCounts": {
    "1x1": 108,
    "2x2": 9
   },
   "tileCount": 117,
   "tiles": [
    {
     "id": "t001",
     "x": 5,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 3,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 7,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 9,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 3,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 7,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 5,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 5,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 1,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t094",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t095",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t096",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t097",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t098",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t099",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t100",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t101",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t102",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t103",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t104",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t105",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t106",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t107",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t108",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t109",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t110",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t111",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t112",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t113",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t114",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t115",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t116",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t117",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "five-stones",
   "name": "Five stones",
   "index": 104,
   "width": 12,
   "height": 12,
   "description": "4x4 center and four 2x2s in a 1x1 field.",
   "sizes": [
    "1x1",
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 112,
    "2x2": 4,
    "4x4": 1
   },
   "tileCount": 117,
   "tiles": [
    {
     "id": "t001",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 2,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 1,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t094",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t095",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t096",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t097",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t098",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t099",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t100",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t101",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t102",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t103",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t104",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t105",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t106",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t107",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t108",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t109",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t110",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t111",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t112",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t113",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t114",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t115",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t116",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t117",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "totem",
   "name": "Totem",
   "index": 105,
   "width": 12,
   "height": 12,
   "description": "One standing 3x9 in a 1x1 field.",
   "sizes": [
    "1x1",
    "3x9"
   ],
   "tileCounts": {
    "1x1": 117,
    "3x9": 1
   },
   "tileCount": 118,
   "tiles": [
    {
     "id": "t001",
     "x": 4,
     "y": 1,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 1,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 3,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t094",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t095",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t096",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t097",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t098",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t099",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t100",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t101",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t102",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t103",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t104",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t105",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t106",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t107",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t108",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t109",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t110",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t111",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t112",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t113",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t114",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t115",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t116",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t117",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t118",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "polka",
   "name": "Polka",
   "index": 106,
   "width": 12,
   "height": 12,
   "description": "Nine 2x2 dots on a 4-inch pitch in 1x1.",
   "sizes": [
    "1x1",
    "2x2"
   ],
   "tileCounts": {
    "1x1": 108,
    "2x2": 9
   },
   "tileCount": 117,
   "tiles": [
    {
     "id": "t001",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 6,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 1,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 5,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t094",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t095",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t096",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t097",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t098",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t099",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t100",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t101",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t102",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t103",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t104",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t105",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t106",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t107",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t108",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t109",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t110",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t111",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t112",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t113",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t114",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t115",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t116",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t117",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "three-bars",
   "name": "Three bars",
   "index": 107,
   "width": 12,
   "height": 12,
   "description": "Three 2x8 bars in a 1x1 field.",
   "sizes": [
    "1x1",
    "2x8"
   ],
   "tileCounts": {
    "1x1": 96,
    "2x8": 3
   },
   "tileCount": 99,
   "tiles": [
    {
     "id": "t001",
     "x": 2,
     "y": 2,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 5,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 2,
     "y": 8,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 1,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t094",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t095",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t096",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t097",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t098",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t099",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "crossed-channels",
   "name": "Crossed channels",
   "index": 108,
   "width": 12,
   "height": 12,
   "description": "2x2 field cut by two 1x1 channels each way.",
   "sizes": [
    "1x1",
    "2x2"
   ],
   "tileCounts": {
    "1x1": 44,
    "2x2": 25
   },
   "tileCount": 69,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 2,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 5,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 5,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 5,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 7,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 7,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 7,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 7,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 10,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 10,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "mondrian-ii",
   "name": "Mondrian II",
   "index": 109,
   "width": 12,
   "height": 12,
   "description": "Twelve tiles, three sizes.",
   "sizes": [
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 4,
    "2x8": 4,
    "4x4": 4
   },
   "tileCount": 12,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 2,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 2,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "mondrian-iii",
   "name": "Mondrian III",
   "index": 110,
   "width": 12,
   "height": 12,
   "description": "A 2x8 arch over five 4x4s.",
   "sizes": [
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x8": 4,
    "4x4": 5
   },
   "tileCount": 9,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 2,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 6,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 6,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "plank-mosaic",
   "name": "Plank & mosaic",
   "index": 111,
   "width": 12,
   "height": 12,
   "description": "3x9s, 4x4s and a 2x8 with 1x1 slivers.",
   "sizes": [
    "1x1",
    "2x8",
    "3x9",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 15,
    "2x8": 1,
    "3x9": 3,
    "4x4": 2
   },
   "tileCount": 21,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 3,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 3,
     "y": 3,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 7,
     "y": 3,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t006",
     "x": 3,
     "y": 7,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t007",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "hearth",
   "name": "Hearth",
   "index": 112,
   "width": 12,
   "height": 12,
   "description": "2x8 frame with 2x2 corners, 2x2 ring, 4x4 heart.",
   "sizes": [
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 16,
    "2x8": 4,
    "4x4": 1
   },
   "tileCount": 21,
   "tiles": [
    {
     "id": "t001",
     "x": 2,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 2,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "hearth-mosaic",
   "name": "Hearth, mosaic",
   "index": 113,
   "width": 12,
   "height": 12,
   "description": "2x8 frame with 2x2 corners around 64 1x1.",
   "sizes": [
    "1x1",
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "1x1": 64,
    "2x2": 4,
    "2x8": 4
   },
   "tileCount": 72,
   "tiles": [
    {
     "id": "t001",
     "x": 2,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 3,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 5,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 6,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "lanes",
   "name": "Lanes",
   "index": 114,
   "width": 12,
   "height": 12,
   "description": "4x4 lanes flanking a lane of standing 2x8.",
   "sizes": [
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 4,
    "2x8": 2,
    "4x4": 6
   },
   "tileCount": 12,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "rails-and-panes",
   "name": "Rails and panes",
   "index": 115,
   "width": 16,
   "height": 16,
   "description": "4x4 panes, standing 2x8 rails, 2x2 ties.",
   "sizes": [
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 12,
    "2x8": 4,
    "4x4": 9
   },
   "tileCount": 25,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 6,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 6,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 12,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 12,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 12,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t011",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t013",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 6,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 12,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 14,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 12,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 14,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "quilt-blocks",
   "name": "Quilt blocks",
   "index": 116,
   "width": 16,
   "height": 16,
   "description": "An 8x8 block of two 4x4s and two 2x8s, rotated a quarter turn each time.",
   "sizes": [
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x8": 8,
    "4x4": 8
   },
   "tileCount": 16,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 12,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 4,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t007",
     "x": 8,
     "y": 6,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t008",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 12,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t012",
     "x": 12,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t015",
     "x": 0,
     "y": 8,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t016",
     "x": 4,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "framed-windmill",
   "name": "Framed windmill",
   "index": 117,
   "width": 16,
   "height": 16,
   "description": "2x8 frame around the 3x9 windmill.",
   "sizes": [
    "2x2",
    "2x8",
    "3x9"
   ],
   "tileCounts": {
    "2x2": 13,
    "2x8": 6,
    "3x9": 4
   },
   "tileCount": 23,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 14,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 8,
     "y": 14,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 14,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t009",
     "x": 14,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 14,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 2,
     "y": 2,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t012",
     "x": 11,
     "y": 2,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t013",
     "x": 5,
     "y": 11,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t014",
     "x": 2,
     "y": 5,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t015",
     "x": 5,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 9,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 5,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 7,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 5,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 7,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 9,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "framed-mondrian",
   "name": "Framed Mondrian",
   "index": 118,
   "width": 16,
   "height": 16,
   "description": "2x8 frame around Mondrian.",
   "sizes": [
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 4,
    "2x8": 12,
    "4x4": 3
   },
   "tileCount": 19,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 14,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 8,
     "y": 14,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 14,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t009",
     "x": 14,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 14,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 2,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 6,
     "y": 2,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 4,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t014",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 12,
     "y": 4,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t016",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t017",
     "x": 4,
     "y": 6,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 6,
     "y": 12,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "framed-hopscotch",
   "name": "Framed hopscotch",
   "index": 119,
   "width": 16,
   "height": 16,
   "description": "2x8 frame around the hopscotch lattice.",
   "sizes": [
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 20,
    "2x8": 6,
    "4x4": 5
   },
   "tileCount": 31,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 14,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 8,
     "y": 14,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 14,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t009",
     "x": 14,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 14,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 2,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 4,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 6,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 6,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 8,
     "y": 10,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 12,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 12,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 12,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 2,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 2,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 4,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 12,
     "y": 12,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "freeform-ii",
   "name": "Freeform II",
   "index": 120,
   "width": 12,
   "height": 12,
   "description": "Plank-heavy random mix.",
   "sizes": [
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 4,
    "2x8": 6,
    "4x4": 2
   },
   "tileCount": 12,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t007",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 10,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t011",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "freeform-mosaic",
   "name": "Freeform mosaic",
   "index": 121,
   "width": 12,
   "height": 12,
   "description": "Random mix with a lot of 1x1.",
   "sizes": [
    "1x1",
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 36,
    "2x2": 15,
    "4x4": 3
   },
   "tileCount": 54,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 5,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 7,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 2,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 9,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 2,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 8,
     "y": 3,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 5,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 0,
     "y": 5,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 4,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 6,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 8,
     "y": 7,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 1,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 3,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "thick-and-thin",
   "name": "Thick and thin",
   "index": 122,
   "width": 12,
   "height": 12,
   "description": "Courses of 4x4 and 2x2 alternating.",
   "sizes": [
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 12,
    "4x4": 6
   },
   "tileCount": 18,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 4,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 4,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 8,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "ribbon",
   "name": "Ribbon",
   "index": 123,
   "width": 12,
   "height": 12,
   "description": "1x1 ribbons between 2x8 and 4x4 courses.",
   "sizes": [
    "1x1",
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 48,
    "2x2": 4,
    "2x8": 2,
    "4x4": 3
   },
   "tileCount": 57,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 1,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t014",
     "x": 8,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 1,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 3,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 2,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 4,
     "y": 9,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t046",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "gradient",
   "name": "Gradient",
   "index": 124,
   "width": 12,
   "height": 12,
   "description": "4x4 to 2x2 to 1x1, top to bottom.",
   "sizes": [
    "1x1",
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 48,
    "2x2": 12,
    "4x4": 3
   },
   "tileCount": 63,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 4,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 4,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 4,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 8,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "bands",
   "name": "Bands",
   "index": 125,
   "width": 12,
   "height": 12,
   "description": "A 2x8 course, then a 2-inch band of 1x1, repeated.",
   "sizes": [
    "1x1",
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "1x1": 72,
    "2x2": 6,
    "2x8": 3
   },
   "tileCount": 81,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 3,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 4,
     "y": 4,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 6,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 7,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 7,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 0,
     "y": 8,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t056",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "gate",
   "name": "Gate",
   "index": 126,
   "width": 12,
   "height": 12,
   "description": "Two 3x9 posts and a sill around a 2x2 field.",
   "sizes": [
    "1x1",
    "2x2",
    "3x9"
   ],
   "tileCounts": {
    "1x1": 15,
    "2x2": 12,
    "3x9": 3
   },
   "tileCount": 30,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 9,
     "y": 0,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 3,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 5,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 7,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 5,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 7,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 3,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 7,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 3,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 5,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 7,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "staircase-planks",
   "name": "Staircase planks",
   "index": 127,
   "width": 12,
   "height": 12,
   "description": "3x9s stepping one inch per course, 1x1 ends.",
   "sizes": [
    "1x1",
    "3x9"
   ],
   "tileCounts": {
    "1x1": 36,
    "3x9": 4
   },
   "tileCount": 40,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 1,
     "y": 3,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t012",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 6,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t022",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 3,
     "y": 9,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t032",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "fringe",
   "name": "Fringe",
   "index": 128,
   "width": 12,
   "height": 12,
   "description": "Six standing 2x8s over a 4-inch 1x1 fringe.",
   "sizes": [
    "1x1",
    "2x8"
   ],
   "tileCounts": {
    "1x1": 48,
    "2x8": 6
   },
   "tileCount": 54,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "lattice",
   "name": "Lattice",
   "index": 129,
   "width": 12,
   "height": 12,
   "description": "2x2s on a 3-inch pitch with 1x1 lines between.",
   "sizes": [
    "1x1",
    "2x2"
   ],
   "tileCounts": {
    "1x1": 80,
    "2x2": 16
   },
   "tileCount": 96,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 3,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 3,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 6,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 6,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 9,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 9,
     "y": 3,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 9,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 9,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 5,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t094",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t095",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t096",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "interlock",
   "name": "Interlock",
   "index": 130,
   "width": 12,
   "height": 12,
   "description": "Four lying 2x8s, two standing, three 4x4s.",
   "sizes": [
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x8": 6,
    "4x4": 3
   },
   "tileCount": 9,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 2,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 4,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 6,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "tetris",
   "name": "Tetris",
   "index": 131,
   "width": 12,
   "height": 12,
   "description": "Fifteen pieces that just happen to fit.",
   "sizes": [
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 8,
    "2x8": 3,
    "4x4": 4
   },
   "tileCount": 15,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 0,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 2,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 8,
     "y": 2,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 4,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 8,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "big-pinwheel",
   "name": "Big pinwheel",
   "index": 132,
   "width": 16,
   "height": 16,
   "description": "2x8 pinwheel in a 3-inch 1x1 surround.",
   "sizes": [
    "1x1",
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 156,
    "2x2": 5,
    "2x8": 4,
    "4x4": 1
   },
   "tileCount": 166,
   "tiles": [
    {
     "id": "t001",
     "x": 3,
     "y": 3,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 11,
     "y": 3,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 5,
     "y": 11,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 3,
     "y": 5,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t005",
     "x": 5,
     "y": 5,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 9,
     "y": 5,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 9,
     "y": 7,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 5,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 7,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 9,
     "y": 9,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 12,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 13,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 14,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 15,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 1,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 12,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 13,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 14,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 15,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 12,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 13,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 14,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 15,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 13,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 14,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 15,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 13,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 14,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 15,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 13,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 14,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 15,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 13,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 14,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 15,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 13,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 14,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 15,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 13,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 14,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t094",
     "x": 15,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t095",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t096",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t097",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t098",
     "x": 13,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t099",
     "x": 14,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t100",
     "x": 15,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t101",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t102",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t103",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t104",
     "x": 13,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t105",
     "x": 14,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t106",
     "x": 15,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t107",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t108",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t109",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t110",
     "x": 13,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t111",
     "x": 14,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t112",
     "x": 15,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t113",
     "x": 0,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t114",
     "x": 1,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t115",
     "x": 2,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t116",
     "x": 13,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t117",
     "x": 14,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t118",
     "x": 15,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t119",
     "x": 0,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t120",
     "x": 1,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t121",
     "x": 2,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t122",
     "x": 3,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t123",
     "x": 4,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t124",
     "x": 5,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t125",
     "x": 6,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t126",
     "x": 7,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t127",
     "x": 8,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t128",
     "x": 9,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t129",
     "x": 10,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t130",
     "x": 11,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t131",
     "x": 12,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t132",
     "x": 13,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t133",
     "x": 14,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t134",
     "x": 15,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t135",
     "x": 0,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t136",
     "x": 1,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t137",
     "x": 2,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t138",
     "x": 3,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t139",
     "x": 4,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t140",
     "x": 5,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t141",
     "x": 6,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t142",
     "x": 7,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t143",
     "x": 8,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t144",
     "x": 9,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t145",
     "x": 10,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t146",
     "x": 11,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t147",
     "x": 12,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t148",
     "x": 13,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t149",
     "x": 14,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t150",
     "x": 15,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t151",
     "x": 0,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t152",
     "x": 1,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t153",
     "x": 2,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t154",
     "x": 3,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t155",
     "x": 4,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t156",
     "x": 5,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t157",
     "x": 6,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t158",
     "x": 7,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t159",
     "x": 8,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t160",
     "x": 9,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t161",
     "x": 10,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t162",
     "x": 11,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t163",
     "x": 12,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t164",
     "x": 13,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t165",
     "x": 14,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t166",
     "x": 15,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "double-windmill",
   "name": "Double windmill",
   "index": 133,
   "width": 18,
   "height": 18,
   "description": "3x9 windmill inside a 3x9 frame.",
   "sizes": [
    "1x1",
    "2x2",
    "3x9"
   ],
   "tileCounts": {
    "1x1": 18,
    "2x2": 9,
    "3x9": 10
   },
   "tileCount": 37,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t002",
     "x": 9,
     "y": 0,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 15,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t004",
     "x": 9,
     "y": 15,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 3,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t006",
     "x": 15,
     "y": 3,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 1,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 2,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 1,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 2,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 0,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 1,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 2,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 15,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 16,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 17,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 15,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 16,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 17,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 15,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 16,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 17,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 3,
     "y": 3,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t026",
     "x": 12,
     "y": 3,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t027",
     "x": 6,
     "y": 12,
     "w": 9,
     "h": 3,
     "size": "3x9",
     "orientation": "landscape"
    },
    {
     "id": "t028",
     "x": 3,
     "y": 6,
     "w": 3,
     "h": 9,
     "size": "3x9",
     "orientation": "portrait"
    },
    {
     "id": "t029",
     "x": 6,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 8,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "x-marks-mosaic",
   "name": "X marks, mosaic",
   "index": 134,
   "width": 12,
   "height": 12,
   "description": "Five 4x4s on the diagonals in a 1x1 field.",
   "sizes": [
    "1x1",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 64,
    "4x4": 5
   },
   "tileCount": 69,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "plus-mosaic",
   "name": "Plus, mosaic",
   "index": 135,
   "width": 12,
   "height": 12,
   "description": "4x4 cross in a 1x1 field.",
   "sizes": [
    "1x1",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 64,
    "4x4": 5
   },
   "tileCount": 69,
   "tiles": [
    {
     "id": "t001",
     "x": 4,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 8,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 4,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 1,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 3,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pillars",
   "name": "Pillars",
   "index": 136,
   "width": 12,
   "height": 12,
   "description": "Alternating 1-inch 1x1 lines and 2x2 columns.",
   "sizes": [
    "1x1",
    "2x2"
   ],
   "tileCounts": {
    "1x1": 48,
    "2x2": 24
   },
   "tileCount": 72,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 1,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 1,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 1,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 1,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 1,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 1,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 3,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 3,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 4,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 4,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 6,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 6,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 7,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 7,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 7,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 7,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 7,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 7,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 9,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 9,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "basketweave-pencil",
   "name": "Basketweave, pencil",
   "index": 137,
   "width": 18,
   "height": 18,
   "description": "The 16x16 basketweave with a 1x1 border.",
   "sizes": [
    "1x1",
    "2x8"
   ],
   "tileCounts": {
    "1x1": 68,
    "2x8": 16
   },
   "tileCount": 84,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 1,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 5,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 6,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 7,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 8,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 10,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 11,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 12,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 12,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 13,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 13,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 14,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 14,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 15,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 15,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 16,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 16,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 17,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 17,
     "y": 17,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 17,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 17,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 17,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 17,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 17,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 17,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 17,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 17,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 17,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 17,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 17,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 0,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 17,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 0,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 17,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 0,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 17,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 0,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 17,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 0,
     "y": 16,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 17,
     "y": 16,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 1,
     "y": 1,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t070",
     "x": 1,
     "y": 3,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t071",
     "x": 1,
     "y": 5,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t072",
     "x": 1,
     "y": 7,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t073",
     "x": 1,
     "y": 9,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t074",
     "x": 3,
     "y": 9,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t075",
     "x": 5,
     "y": 9,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t076",
     "x": 7,
     "y": 9,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t077",
     "x": 9,
     "y": 1,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t078",
     "x": 11,
     "y": 1,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t079",
     "x": 13,
     "y": 1,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t080",
     "x": 15,
     "y": 1,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t081",
     "x": 9,
     "y": 9,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t082",
     "x": 9,
     "y": 11,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t083",
     "x": 9,
     "y": 13,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    },
    {
     "id": "t084",
     "x": 9,
     "y": 15,
     "w": 8,
     "h": 2,
     "size": "2x8",
     "orientation": "landscape"
    }
   ]
  },
  {
   "id": "windowpane-mosaic",
   "name": "Windowpane, mosaic",
   "index": 138,
   "width": 16,
   "height": 16,
   "description": "4x4 panes with 1x1 mullions.",
   "sizes": [
    "1x1",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 112,
    "4x4": 9
   },
   "tileCount": 121,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 6,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 6,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 12,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 12,
     "y": 6,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 12,
     "y": 12,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 4,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 12,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 13,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 14,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 15,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 4,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 5,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 12,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 13,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 14,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 15,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 10,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 12,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 13,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 14,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 15,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t094",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t095",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t096",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t097",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t098",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t099",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t100",
     "x": 10,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t101",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t102",
     "x": 12,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t103",
     "x": 13,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t104",
     "x": 14,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t105",
     "x": 15,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t106",
     "x": 4,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t107",
     "x": 5,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t108",
     "x": 10,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t109",
     "x": 11,
     "y": 12,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t110",
     "x": 4,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t111",
     "x": 5,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t112",
     "x": 10,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t113",
     "x": 11,
     "y": 13,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t114",
     "x": 4,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t115",
     "x": 5,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t116",
     "x": 10,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t117",
     "x": 11,
     "y": 14,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t118",
     "x": 4,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t119",
     "x": 5,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t120",
     "x": 10,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t121",
     "x": 11,
     "y": 15,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "checker-quads",
   "name": "Checker, quads",
   "index": 139,
   "width": 12,
   "height": 12,
   "description": "4x4s alternating with quads of 2x2.",
   "sizes": [
    "2x2",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 16,
    "4x4": 5
   },
   "tileCount": 21,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 2,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 8,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 8,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "checker-mosaic",
   "name": "Checker, mosaic",
   "index": 140,
   "width": 12,
   "height": 12,
   "description": "4x4s alternating with 16-piece 1x1 squares.",
   "sizes": [
    "1x1",
    "4x4"
   ],
   "tileCounts": {
    "1x1": 64,
    "4x4": 5
   },
   "tileCount": 69,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 0,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 8,
     "y": 0,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 8,
     "y": 8,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "thin-diagonal",
   "name": "Thin diagonal",
   "index": 141,
   "width": 12,
   "height": 12,
   "description": "A 2x2 diagonal through 1x1.",
   "sizes": [
    "1x1",
    "2x2"
   ],
   "tileCounts": {
    "1x1": 120,
    "2x2": 6
   },
   "tileCount": 126,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 10,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 9,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 9,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 6,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 7,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 6,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 7,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 4,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 4,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 3,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t094",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t095",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t096",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t097",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t098",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t099",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t100",
     "x": 3,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t101",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t102",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t103",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t104",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t105",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t106",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t107",
     "x": 0,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t108",
     "x": 1,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t109",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t110",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t111",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t112",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t113",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t114",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t115",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t116",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t117",
     "x": 0,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t118",
     "x": 1,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t119",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t120",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t121",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t122",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t123",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t124",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t125",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t126",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "thin-x",
   "name": "Thin X",
   "index": 142,
   "width": 12,
   "height": 12,
   "description": "Two 2x2 diagonals through 1x1.",
   "sizes": [
    "1x1",
    "2x2"
   ],
   "tileCounts": {
    "1x1": 96,
    "2x2": 12
   },
   "tileCount": 108,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 4,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 6,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 8,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 2,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 6,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 4,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 3,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 4,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 6,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 7,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 9,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 3,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 4,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 6,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 7,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 9,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 0,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 1,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 4,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t032",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 6,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 7,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 10,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 0,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 1,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 4,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 6,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 7,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 10,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 0,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 1,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t047",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 3,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 9,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 10,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 0,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 1,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 3,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 9,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 10,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t061",
     "x": 0,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t062",
     "x": 1,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t063",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t064",
     "x": 3,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t065",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t066",
     "x": 9,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t067",
     "x": 10,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t068",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t069",
     "x": 0,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t070",
     "x": 1,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t071",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t072",
     "x": 3,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t073",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t074",
     "x": 9,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t075",
     "x": 10,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t076",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t077",
     "x": 0,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t078",
     "x": 1,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t079",
     "x": 4,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t080",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t081",
     "x": 6,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t082",
     "x": 7,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t083",
     "x": 10,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t084",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t085",
     "x": 0,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t086",
     "x": 1,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t087",
     "x": 4,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t088",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t089",
     "x": 6,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t090",
     "x": 7,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t091",
     "x": 10,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t092",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t093",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t094",
     "x": 3,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t095",
     "x": 4,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t096",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t097",
     "x": 6,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t098",
     "x": 7,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t099",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t100",
     "x": 9,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t101",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t102",
     "x": 3,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t103",
     "x": 4,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t104",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t105",
     "x": 6,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t106",
     "x": 7,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t107",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t108",
     "x": 9,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "window",
   "name": "Window",
   "index": 143,
   "width": 12,
   "height": 12,
   "description": "4x4 pane, standing 2x8 jambs, 2x2 surround.",
   "sizes": [
    "2x2",
    "2x8",
    "4x4"
   ],
   "tileCounts": {
    "2x2": 24,
    "2x8": 2,
    "4x4": 1
   },
   "tileCount": 27,
   "tiles": [
    {
     "id": "t001",
     "x": 4,
     "y": 4,
     "w": 4,
     "h": 4,
     "size": "4x4",
     "orientation": "square"
    },
    {
     "id": "t002",
     "x": 2,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t003",
     "x": 8,
     "y": 2,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t004",
     "x": 4,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 6,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 4,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 2,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 4,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 8,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 10,
     "y": 0,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 0,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 10,
     "y": 2,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 0,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t017",
     "x": 10,
     "y": 4,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 0,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 10,
     "y": 6,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 10,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 2,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 4,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 8,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 10,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    }
   ]
  },
  {
   "id": "pinstripe-standing",
   "name": "Pinstripe, standing",
   "index": 144,
   "width": 12,
   "height": 12,
   "description": "Standing 2x8 columns with 1x1 pinstripes between.",
   "sizes": [
    "1x1",
    "2x2",
    "2x8"
   ],
   "tileCounts": {
    "1x1": 48,
    "2x2": 8,
    "2x8": 4
   },
   "tileCount": 60,
   "tiles": [
    {
     "id": "t001",
     "x": 0,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t002",
     "x": 0,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t003",
     "x": 0,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t004",
     "x": 2,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t005",
     "x": 2,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t006",
     "x": 2,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t007",
     "x": 2,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t008",
     "x": 2,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t009",
     "x": 2,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t010",
     "x": 2,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t011",
     "x": 2,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t012",
     "x": 2,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t013",
     "x": 2,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t014",
     "x": 2,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t015",
     "x": 2,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t016",
     "x": 3,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t017",
     "x": 3,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t018",
     "x": 3,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t019",
     "x": 5,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t020",
     "x": 5,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t021",
     "x": 5,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t022",
     "x": 5,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t023",
     "x": 5,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t024",
     "x": 5,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t025",
     "x": 5,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t026",
     "x": 5,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t027",
     "x": 5,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t028",
     "x": 5,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t029",
     "x": 5,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t030",
     "x": 5,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t031",
     "x": 6,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t032",
     "x": 6,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t033",
     "x": 6,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t034",
     "x": 8,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t035",
     "x": 8,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t036",
     "x": 8,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t037",
     "x": 8,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t038",
     "x": 8,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t039",
     "x": 8,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t040",
     "x": 8,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t041",
     "x": 8,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t042",
     "x": 8,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t043",
     "x": 8,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t044",
     "x": 8,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t045",
     "x": 8,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t046",
     "x": 9,
     "y": 0,
     "w": 2,
     "h": 8,
     "size": "2x8",
     "orientation": "portrait"
    },
    {
     "id": "t047",
     "x": 9,
     "y": 8,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t048",
     "x": 9,
     "y": 10,
     "w": 2,
     "h": 2,
     "size": "2x2",
     "orientation": "square"
    },
    {
     "id": "t049",
     "x": 11,
     "y": 0,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t050",
     "x": 11,
     "y": 1,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t051",
     "x": 11,
     "y": 2,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t052",
     "x": 11,
     "y": 3,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t053",
     "x": 11,
     "y": 4,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t054",
     "x": 11,
     "y": 5,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t055",
     "x": 11,
     "y": 6,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t056",
     "x": 11,
     "y": 7,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t057",
     "x": 11,
     "y": 8,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t058",
     "x": 11,
     "y": 9,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t059",
     "x": 11,
     "y": 10,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    },
    {
     "id": "t060",
     "x": 11,
     "y": 11,
     "w": 1,
     "h": 1,
     "size": "1x1",
     "orientation": "square"
    }
   ]
  }
 ]
}